import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { Grid } from 'semantic-ui-react'
import LoadingComponent from '../../../app/layout/LoadingComponents'
import { useStore } from '../../../app/stores/ardstore'
import ArduinoList from './ArduinoList'

export default observer(function ArduinoDashboard () {
  const { arduinoStore } = useStore()
  const { loadArduinos, arduinoRegistry } = arduinoStore
  useEffect(() => {
    if (arduinoRegistry.size <= 0) { loadArduinos() }
  }, [arduinoStore])

  if (arduinoStore.loadingInitial) {
    return <LoadingComponent content="Loading app" />
  }

  return (
    <Grid>
      <Grid.Column width="16">
        <ArduinoList arduinoStore={arduinoStore} />
      </Grid.Column>
    </Grid>
  )
})
